function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1917 1917",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.062,125.83C343.613,125.802 334.198,116.387 334.17,104.938C334.207,93.488 343.613,84.083 355.062,84.055C366.503,84.092 375.908,93.498 375.945,104.938C375.918,116.387 366.511,125.793 355.062,125.83ZM229.744,354.863C160.981,354.863 105.136,299.019 105.136,230.255C105.136,161.493 160.981,105.649 229.744,105.649C298.507,105.649 354.351,161.493 354.351,230.255C354.351,299.019 298.507,354.863 229.744,354.863ZM323.732,0.512L135.755,0.512C60.877,0.512 0,61.39 0,136.267L0,324.244C0,399.113 60.877,460 135.755,460L323.732,460C398.601,460 459.488,399.113 459.488,324.244L459.488,136.267C459.488,61.39 398.601,0.512 323.732,0.512Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.732,230.255C323.732,282.056 281.535,324.244 229.744,324.244C177.943,324.244 135.755,282.047 135.755,230.255C135.755,178.456 177.953,136.267 229.744,136.267C281.544,136.267 323.732,178.465 323.732,230.255Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.947506bf.svg";
export { ForwardRef as ReactComponent };